/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IHosportsBasemoduleTesterViewProps } from './hosports-basemodule-tester';

export default (props: IHosportsBasemoduleTesterViewProps) => {
    return (
        <div className='row'>
            <h2>{'Basemodule Tester'}</h2>
        </div>
    );
};
